export enum EmbeddingModel {
  INTERNAL_EMBEDDING_GENERATOR = 'INTERNAL_EMBEDDING_GENERATOR'
}

export function isEmbeddingModel(value: string): value is EmbeddingModel {
  return Object.values(EmbeddingModel).includes(value as EmbeddingModel);
}
